// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import { type GetAuthByProviderNameCallbackData, type GetAuthByProviderNameCallbackResponse, type GetAuthByProviderNameLoginData, type PostAuthByProviderNameOneTapData, type PostAuthByProviderNameOneTapResponse, type PostAuthMagicLinkSendData, type PostAuthMagicLinkSendResponse, type PostAuthMagicLinkVerifyData, type PostAuthMagicLinkVerifyResponse, type GetAuthSessionInfoResponse, type PostAuthSessionLogoutResponse, type PostAdminIdentifyData, type PostAdminIdentifyResponse, type GetAdminConnectionsData, type GetAdminConnectionsResponse, type PostAdminAuthRefreshData, type PostAdminAuthRefreshResponse, type PostAuthConfigsData, type PostAuthConfigsResponse, type GetAuthConfigsData, type GetAuthConfigsResponse, type GetAuthConfigsByNanoidData, type GetAuthConfigsByNanoidResponse, type PatchAuthConfigsByNanoidData, type PatchAuthConfigsByNanoidResponse, type DeleteAuthConfigsByNanoidData, type DeleteAuthConfigsByNanoidResponse, type PatchAuthConfigsByNanoidByStatusData, type PatchAuthConfigsByNanoidByStatusResponse, type PostCliCreateSessionResponse, type GetCliGetSessionData, type GetCliGetSessionResponse, type PutCliLinkSessionData, type PutCliLinkSessionResponse, type GetConnectedAccountsData, type GetConnectedAccountsResponse, type PostConnectedAccountsData, type PostConnectedAccountsResponse, type GetConnectedAccountsByNanoidData, type GetConnectedAccountsByNanoidResponse, type DeleteConnectedAccountsByNanoidData, type DeleteConnectedAccountsByNanoidResponse, type PatchConnectedAccountsByNanoIdStatusData, type PatchConnectedAccountsByNanoIdStatusResponse, type PostConnectedAccountsByNanoidRefreshData, type PostConnectedAccountsByNanoidRefreshResponse, type PostInternalTriggerLogsData, type PostInternalTriggerLogsResponse, type PostInternalActionExecutionLogsData, type PostInternalActionExecutionLogsResponse, type GetInternalActionExecutionFieldsResponse, type GetInternalActionExecutionLogByIdData, type GetInternalActionExecutionLogByIdResponse, type GetOpenapiSpecsListResponse, type PostOpenapiSpecsCreateData, type PostOpenapiSpecsCreateResponse, type DeleteOpenapiSpecsByIdData, type DeleteOpenapiSpecsByIdResponse, type GetOpenapiSpecsStatusByIdData, type GetOpenapiSpecsStatusByIdResponse, type GetOrgApiKeyResponse, type PostOrgApiKeyRegenerateResponse, type GetOrgProjectListResponse, type PostOrgProjectNewData, type PostOrgProjectNewResponse, type DeleteOrgProjectDeleteByProjectIdData, type DeleteOrgProjectDeleteByProjectIdResponse, type GetOrgProjectByProjectIdData, type GetOrgProjectByProjectIdResponse, type GetOrgProjectByProjectIdApiKeysListData, type GetOrgProjectByProjectIdApiKeysListResponse, type PostOrgProjectByProjectIdApiKeysCreateData, type PostOrgProjectByProjectIdApiKeysCreateResponse, type PostOrgProjectByProjectIdApiKeysCreateApiKeyData, type PostOrgProjectByProjectIdApiKeysCreateApiKeyResponse, type DeleteOrgProjectByProjectIdApiKeysRemoveByIdData, type DeleteOrgProjectByProjectIdApiKeysRemoveByIdResponse, type GetOrgProjectWebhookData, type GetOrgProjectWebhookResponse, type DeleteOrgProjectWebhookData, type DeleteOrgProjectWebhookResponse, type PostOrgProjectWebhookUpdateData, type PostOrgProjectWebhookUpdateResponse, type PostOrgProjectWebhookRefreshResponse, type GetTeamMembersListResponse, type PostTeamMembersInviteData, type PostTeamMembersInviteResponse, type DeleteTeamMembersRemoveByIdData, type DeleteTeamMembersRemoveByIdResponse, type PutTeamMembersUpdateByIdData, type PutTeamMembersUpdateByIdResponse, type GetToolkitsData, type GetToolkitsResponse, type GetToolkitsCategoriesData, type GetToolkitsCategoriesResponse, type GetToolkitsBySlugData, type GetToolkitsBySlugResponse, type GetToolsData, type GetToolsResponse, type GetToolsEnumResponse, type GetToolsByToolSlugData, type GetToolsByToolSlugResponse, type PostToolsExecuteByToolSlugData, type PostToolsExecuteByToolSlugResponse, type PostToolsExecuteByToolSlugInputData, type PostToolsExecuteByToolSlugInputResponse, type PostToolsExecuteProxyData, type PostToolsExecuteProxyResponse, type GetTriggerInstancesBySlugByProjectIdHandleData, type GetTriggerInstancesBySlugByProjectIdHandleResponse, type PostTriggerInstancesBySlugByProjectIdHandleData, type PostTriggerInstancesBySlugByProjectIdHandleResponse, type HeadTriggerInstancesBySlugByProjectIdHandleData, type HeadTriggerInstancesBySlugByProjectIdHandleResponse, type PostTriggerInstancesBySlugUpsertData, type PostTriggerInstancesBySlugUpsertResponse, type GetTriggerInstancesActiveData, type GetTriggerInstancesActiveResponse, type DeleteTriggerInstancesManageByTriggerIdData, type DeleteTriggerInstancesManageByTriggerIdResponse, type PatchTriggerInstancesManageByTriggerIdData, type PatchTriggerInstancesManageByTriggerIdResponse, type GetTriggersTypesListEnumResponse, type GetTriggersTypesBySlugData, type GetTriggersTypesBySlugResponse, type GetTriggersTypesData, type GetTriggersTypesResponse, type GetOrgProjectTriggerResponse, type PatchOrgProjectTriggerData, type PatchOrgProjectTriggerResponse, type PostPaymentsSessionData, type PostPaymentsSessionResponse, type PostPaymentsManageSubscriptionData, type PostPaymentsManageSubscriptionResponse, type GetAdminCreatePaymentLinkData, type GetAdminCreatePaymentLinkResponse, type GetMcpValidateByUuidData, type GetMcpValidateByUuidResponse, type GetMcpServersData, type GetMcpServersResponse, type PostMcpServersData, type PostMcpServersResponse, type PostMcpServersCustomData, type PostMcpServersCustomResponse, type PostMcpServersGenerateData, type PostMcpServersGenerateResponse, type GetMcpByIdData, type GetMcpByIdResponse, type PatchMcpByIdData, type PatchMcpByIdResponse, type DeleteMcpByIdData, type DeleteMcpByIdResponse, type GetMcpAppByAppKeyData, type GetMcpAppByAppKeyResponse, type GetFilesListData, type GetFilesListResponse, type PostFilesUploadRequestData, type PostFilesUploadRequestResponse, type PostFilesUploadResponseData, type PostFilesUploadResponseResponse, type GetMigrationGetNanoidData, type GetMigrationGetNanoidResponse, PostOrgProjectNewResponseTransformer, GetOrgProjectByProjectIdResponseTransformer, PostOrgProjectByProjectIdApiKeysCreateResponseTransformer, GetOrgProjectTriggerResponseTransformer, PatchOrgProjectTriggerResponseTransformer } from './types.gen';

/**
 * Handle OAuth provider callback and complete authentication
 * Processes the callback from an OAuth provider after user authentication, validating the returned authorization code and exchanging it for user profile information. On successful verification, creates a user session, sets authentication cookies, and either returns user credentials as JSON or redirects to the application. Also ensures the user has an API key, creating one if needed.
 * @param data The data for the request.
 * @param data.providerName OAuth provider name
 * @param data.code Authorization code from OAuth provider
 * @param data.state State parameter for CSRF protection
 * @param data.authCode Alternative authorization code format
 * @param data.error Error code from OAuth provider
 * @param data.errorDescription Error description from OAuth provider
 * @returns unknown Successfully verified OAuth login. Returns authentication tokens and user details.
 * @returns void Successful preflight response for CORS request.
 * @throws ApiError
 */
export const getAuthByProviderNameCallback = (data: GetAuthByProviderNameCallbackData): CancelablePromise<GetAuthByProviderNameCallbackResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/auth/{provider_name}/callback',
        path: {
            provider_name: data.providerName
        },
        query: {
            code: data.code,
            state: data.state,
            authCode: data.authCode,
            error: data.error,
            error_description: data.errorDescription
        },
        errors: {
            302: 'Redirect to application with authentication result. Used when authentication completes but needs to return the user to the application interface.',
            400: 'Bad request. The callback request is missing required parameters or contains invalid data.',
            401: 'Unauthorized. The OAuth provider rejected the authentication request or returned an error.',
            404: 'Not found. The organization, member, or project associated with the authenticated user could not be found.',
            500: 'Internal server error. An unexpected error occurred while processing the OAuth callback.'
        }
    });
};

/**
 * Initiate OAuth login flow with specified provider
 * Starts the OAuth 2.0 authorization flow with the specified authentication provider. This endpoint generates the authorization URL with appropriate scopes and redirects the user to the provider's login page. After authentication with the provider, the user will be redirected back to the application via the callback endpoint.
 * @param data The data for the request.
 * @param data.providerName Name of the OAuth provider to use for authentication (e.g., "google", "github")
 * @param data.redirectUri Custom redirect URI after authentication
 * @throws ApiError
 */
export const getAuthByProviderNameLogin = (data: GetAuthByProviderNameLoginData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/auth/{provider_name}/login',
        path: {
            provider_name: data.providerName
        },
        query: {
            redirectUri: data.redirectUri
        },
        errors: {
            302: 'Redirect to OAuth provider authorization page to begin authentication flow',
            400: 'Bad request. The provider name is invalid or the request is malformed.',
            404: 'Not found. The specified OAuth provider is not supported.',
            500: 'Internal server error. An unexpected error occurred while initiating the OAuth flow.'
        }
    });
};

/**
 * Handle one-tap sign-in for supported providers
 * @param data The data for the request.
 * @param data.providerName
 * @param data.requestBody
 * @returns unknown Successfully logged in
 * @throws ApiError
 */
export const postAuthByProviderNameOneTap = (data: PostAuthByProviderNameOneTapData): CancelablePromise<PostAuthByProviderNameOneTapResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/auth/{provider_name}/one-tap',
        path: {
            provider_name: data.providerName
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            302: 'Redirect to app with authentication result',
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Send magic link authentication email to user
 * Initiates the magic link authentication flow by sending an email containing a secure one-time login link to the specified email address. The user can click this link to authenticate without needing a password. This endpoint handles both regular authentication and MCP-specific authentication flows.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Magic link email sent successfully. The user will receive an email with a secure authentication link.
 * @throws ApiError
 */
export const postAuthMagicLinkSend = (data: PostAuthMagicLinkSendData = {}): CancelablePromise<PostAuthMagicLinkSendResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/auth/magic_link/send',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad Request. The email address may be invalid or missing required parameters.',
            404: 'Resource not found. The requested resource could not be found.',
            429: 'Too Many Requests. Rate limit exceeded for magic link email sending.',
            500: 'Internal server error. An unexpected error occurred while sending the magic link email.'
        }
    });
};

/**
 * Verify magic link token and authenticate user
 * Validates a magic link token received by email and completes the authentication process. Upon successful verification, creates a session, sets authentication cookies, and returns user credentials. Also ensures the user has an API key, creating one if needed. The magic link can only be used once unless specifically configured for testing.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Magic link successfully verified and user authenticated. Returns authentication tokens and user details.
 * @throws ApiError
 */
export const postAuthMagicLinkVerify = (data: PostAuthMagicLinkVerifyData = {}): CancelablePromise<PostAuthMagicLinkVerifyResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/auth/magic_link/verify',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request. The request is missing required parameters or contains invalid data.',
            401: 'Unauthorized. The magic link token is invalid, expired, or has already been used.',
            404: 'Not found. The organization, member, or project associated with the magic link could not be found.',
            500: 'Internal server error. An unexpected error occurred while processing the magic link verification.'
        }
    });
};

/**
 * Get current user session information
 * Retrieves detailed information about the current authenticated user session, including project details, organization membership, and API key information if applicable. This endpoint is useful for verifying authentication status and retrieving contextual information about the authenticated user and their access privileges.
 * @returns unknown Session is valid and active. Returns detailed information about the authenticated user, their project, and organization.
 * @throws ApiError
 */
export const getAuthSessionInfo = (): CancelablePromise<GetAuthSessionInfoResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/auth/session/info',
        errors: {
            400: 'Bad request. The request format may be invalid or missing required parameters.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid or expired.',
            403: 'Forbidden. The authenticated user does not have permission to access this resource.',
            404: 'Not found. The requested project, organization, or member resource could not be found.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * End user session and clear authentication
 * Terminates the current user session by invalidating authentication cookies and tokens. This effectively signs the user out of the application. After logout, the user will need to authenticate again to access protected resources.
 * @returns unknown Logout operation completed successfully. The session has been terminated and authentication cookies have been invalidated.
 * @throws ApiError
 */
export const postAuthSessionLogout = (): CancelablePromise<PostAuthSessionLogoutResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/auth/session/logout',
        errors: {
            401: 'Unauthorized. The request requires valid authentication which was not provided.',
            500: 'Internal server error. An unexpected error occurred while processing the logout request.'
        }
    });
};

/**
 * Identify a user by hash and retrieve client details
 * Administrative endpoint that resolves a secure hash to user information and retrieves or creates an API key for the user. This endpoint is used during authentication flows to securely identify users and provision access.
 * @param data The data for the request.
 * @param data.requestBody Hash information used to identify the user
 * @returns unknown Successfully identified client and retrieved account details
 * @throws ApiError
 */
export const postAdminIdentify = (data: PostAdminIdentifyData): CancelablePromise<PostAdminIdentifyResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/admin/identify',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request - Invalid hash provided or other validation error',
            401: 'Unauthorized - Invalid admin credentials or insufficient permissions',
            404: 'Not found - User with the provided hash could not be found',
            500: 'Internal server error - Failed to identify client due to server-side issue'
        }
    });
};

/**
 * List connections for a specific toolkit or project
 * Administrative endpoint that retrieves all active connections for a given toolkit slug (via query parameter) or project auto ID (via x-client-auto-id header). Exactly one filter must be provided. This is primarily used for token refresh operations and system maintenance. Only includes non-deleted connections with OAuth2 or JWT authentication types.
 * @param data The data for the request.
 * @param data.xComposioAdminToken Admin authentication token required for administrative operations
 * @param data.toolkitSlug The unique identifier slug of the toolkit to filter connections by
 * @param data.xClientAutoId Optional client auto ID to filter connections for custom apps by project
 * @returns unknown Successfully retrieved list of connections matching the filter criteria
 * @throws ApiError
 */
export const getAdminConnections = (data: GetAdminConnectionsData): CancelablePromise<GetAdminConnectionsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/admin/connections',
        headers: {
            'x-composio-admin-token': data.xComposioAdminToken,
            'x-client-auto-id': data.xClientAutoId
        },
        query: {
            toolkit_slug: data.toolkitSlug
        },
        errors: {
            400: 'Bad request - Invalid filter parameters or conflicting filters provided',
            401: 'Unauthorized - Invalid or missing admin token',
            404: 'Resource not found - The specified toolkit slug or project auto ID does not exist',
            500: 'Internal server error - Failed to retrieve connections due to a server-side issue'
        }
    });
};

/**
 * Batch refresh access tokens for connected accounts
 * Administrative endpoint that refreshes authentication tokens for multiple connected accounts in parallel. This is useful for proactive token refresh to prevent authentication failures or for recovering from authentication issues across multiple connections.
 * @param data The data for the request.
 * @param data.xComposioAdminToken Admin authentication token required for administrative operations
 * @param data.requestBody Connection IDs to process and parallelism configuration
 * @returns unknown Successfully processed refresh request with detailed results
 * @throws ApiError
 */
export const postAdminAuthRefresh = (data: PostAdminAuthRefreshData): CancelablePromise<PostAdminAuthRefreshResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/admin/auth-refresh',
        headers: {
            'x-composio-admin-token': data.xComposioAdminToken
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request - Invalid parameters provided or other validation error',
            401: 'Unauthorized - Invalid or missing admin token',
            500: 'Internal server error - Failed to process refresh operation due to server-side issue'
        }
    });
};

/**
 * Create new authentication configuration
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully created auth config
 * @throws ApiError
 */
export const postAuthConfigs = (data: PostAuthConfigsData = {}): CancelablePromise<PostAuthConfigsResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/auth_configs',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Not found',
            500: 'Internal server error'
        }
    });
};

/**
 * List authentication configurations with optional filters
 * @param data The data for the request.
 * @param data.isComposioManaged Whether to filter by composio managed auth configs
 * @param data.toolkitSlug Comma-separated list of toolkit slugs to filter auth configs by
 * @param data.deprecatedAppId The app id to filter by
 * @param data.deprecatedStatus
 * @param data.showDisabled Show disabled auth configs
 * @param data.search Search auth configs by name
 * @param data.limit Number of items per page
 * @param data.cursor Cursor for pagination. The cursor is a base64 encoded string of the page and limit. The page is the page number and the limit is the number of items per page. The cursor is used to paginate through the items. The cursor is not required for the first page.
 * @returns unknown Successfully fetched auth configs
 * @throws ApiError
 */
export const getAuthConfigs = (data: GetAuthConfigsData = {}): CancelablePromise<GetAuthConfigsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/auth_configs',
        query: {
            is_composio_managed: data.isComposioManaged,
            toolkit_slug: data.toolkitSlug,
            deprecated_app_id: data.deprecatedAppId,
            deprecated_status: data.deprecatedStatus,
            show_disabled: data.showDisabled,
            search: data.search,
            limit: data.limit,
            cursor: data.cursor
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Get single authentication configuration by ID
 * Retrieves detailed information about a specific authentication configuration using its unique identifier.
 * @param data The data for the request.
 * @param data.nanoid The unique identifier of the authentication configuration to retrieve
 * @returns unknown Successfully fetched auth config
 * @throws ApiError
 */
export const getAuthConfigsByNanoid = (data: GetAuthConfigsByNanoidData): CancelablePromise<GetAuthConfigsByNanoidResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/auth_configs/{nanoid}',
        path: {
            nanoid: data.nanoid
        },
        errors: {
            400: 'Bad request - Invalid auth config ID format',
            401: 'Unauthorized - Authentication required',
            404: 'Not found - Auth configuration does not exist',
            500: 'Internal server error - Something went wrong on the server'
        }
    });
};

/**
 * Update an authentication configuration
 * Modifies an existing authentication configuration with new credentials or other settings. Only specified fields will be updated.
 * @param data The data for the request.
 * @param data.nanoid The unique identifier of the authentication configuration to update
 * @param data.requestBody
 * @returns unknown Successfully updated auth config
 * @throws ApiError
 */
export const patchAuthConfigsByNanoid = (data: PatchAuthConfigsByNanoidData): CancelablePromise<PatchAuthConfigsByNanoidResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v3/auth_configs/{nanoid}',
        path: {
            nanoid: data.nanoid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request - Invalid input or credentials format',
            401: 'Unauthorized - Authentication required',
            404: 'Not found - Auth configuration does not exist',
            500: 'Internal server error - Something went wrong on the server'
        }
    });
};

/**
 * Delete an authentication configuration
 * Soft-deletes an authentication configuration by marking it as deleted in the database. This operation cannot be undone.
 * @param data The data for the request.
 * @param data.nanoid The unique identifier of the authentication configuration to delete
 * @returns unknown Successfully deleted auth config
 * @throws ApiError
 */
export const deleteAuthConfigsByNanoid = (data: DeleteAuthConfigsByNanoidData): CancelablePromise<DeleteAuthConfigsByNanoidResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/auth_configs/{nanoid}',
        path: {
            nanoid: data.nanoid
        },
        errors: {
            400: 'Bad request - Invalid auth config ID format',
            401: 'Unauthorized - Authentication required',
            404: 'Auth config not found - The specified configuration does not exist or was already deleted',
            500: 'Internal server error - Something went wrong on the server'
        }
    });
};

/**
 * Enable or disable an authentication configuration
 * Updates the status of an authentication configuration to either enabled or disabled. Disabled configurations cannot be used for new connections.
 * @param data The data for the request.
 * @param data.nanoid The unique identifier of the authentication configuration to update
 * @param data.status The new status to set for the auth configuration
 * @returns unknown Successfully updated auth config status
 * @throws ApiError
 */
export const patchAuthConfigsByNanoidByStatus = (data: PatchAuthConfigsByNanoidByStatusData): CancelablePromise<PatchAuthConfigsByNanoidByStatusResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v3/auth_configs/{nanoid}/{status}',
        path: {
            nanoid: data.nanoid,
            status: data.status
        },
        errors: {
            400: 'Bad request - Invalid auth config ID or status value',
            401: 'Unauthorized - Authentication required',
            404: 'Not found - Auth configuration does not exist',
            500: 'Internal server error - Something went wrong on the server'
        }
    });
};

/**
 * Create a new CLI session with auth code
 * Generates a new CLI session with a random 6-character code. This endpoint is the first step in the CLI authentication flow, creating a session that can later be linked to a user account. The generated code is displayed to the user in the CLI and should be entered in the web interface to complete authentication.
 * @returns unknown CLI session created successfully with a unique ID and temporary authentication code
 * @throws ApiError
 */
export const postCliCreateSession = (): CancelablePromise<PostCliCreateSessionResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/cli/create-session',
        errors: {
            400: 'Bad request - Invalid parameters or malformed request',
            500: 'Internal server error - Failed to create CLI session due to server-side issue'
        }
    });
};

/**
 * Get CLI session details by ID or code
 * Retrieves the current state of a CLI session using either the session ID (UUID) or the 6-character code. This endpoint is used by both the CLI client to check if the session has been linked, and by the web interface to display session details before linking.
 * @param data The data for the request.
 * @param data.id CLI session ID (UUID format) or 6-character code to check. Both formats are supported for flexibility in client implementations.
 * @returns unknown CLI session retrieved successfully. Returns full session details including linked account information if available.
 * @throws ApiError
 */
export const getCliGetSession = (data: GetCliGetSessionData): CancelablePromise<GetCliGetSessionResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/cli/get-session',
        query: {
            id: data.id
        },
        errors: {
            400: 'Invalid session ID or code format. The ID must be either a valid UUID or a 6-character hexadecimal code.',
            404: 'CLI session not found or expired. Sessions expire after 10 minutes from creation.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Link a CLI session to the authenticated user
 * Links a pending CLI session to the currently authenticated user. This is the final step in the CLI authentication flow, where the user enters the code in the web interface and their account is associated with the CLI session, allowing the CLI to act on their behalf.
 * @param data The data for the request.
 * @param data.requestBody The session ID or code to link to the current user
 * @returns unknown CLI session linked successfully. The CLI client can now use this session to authenticate API requests on behalf of the linked user.
 * @throws ApiError
 */
export const putCliLinkSession = (data: PutCliLinkSessionData = {}): CancelablePromise<PutCliLinkSessionResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/v3/cli/link-session',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request. This can occur if: 1) The session ID or code format is invalid, 2) The session is already linked to an account, or 3) The request contains invalid parameters.',
            401: 'Unauthorized. Authentication is required to link a CLI session. The user must be logged in to complete this operation.',
            404: 'Not found. This can occur if: 1) The CLI session does not exist, 2) The session has expired (10-minute lifetime), or 3) The authenticated user account cannot be found.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * List connected accounts with optional filters
 * @param data The data for the request.
 * @param data.toolkitSlugs The toolkit slugs of the connected accounts
 * @param data.statuses The status of the connected account
 * @param data.cursor The cursor to paginate through the connected accounts
 * @param data.limit The limit of the connected accounts to return
 * @param data.userIds The user ids of the connected accounts
 * @param data.authConfigIds The auth config ids of the connected accounts
 * @param data.orderBy The order by of the connected accounts
 * @param data.labels The labels of the connected accounts
 * @returns unknown Successfully retrieved connected accounts
 * @throws ApiError
 */
export const getConnectedAccounts = (data: GetConnectedAccountsData = {}): CancelablePromise<GetConnectedAccountsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/connected_accounts',
        query: {
            toolkit_slugs: data.toolkitSlugs,
            statuses: data.statuses,
            cursor: data.cursor,
            limit: data.limit,
            user_ids: data.userIds,
            auth_config_ids: data.authConfigIds,
            order_by: data.orderBy,
            labels: data.labels
        },
        errors: {
            400: 'Bad request',
            422: 'Unprocessable entity',
            500: 'Internal server error'
        }
    });
};

/**
 * Create a new connected account
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully created connected account
 * @throws ApiError
 */
export const postConnectedAccounts = (data: PostConnectedAccountsData = {}): CancelablePromise<PostConnectedAccountsResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/connected_accounts',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Not found',
            500: 'Internal server error',
            501: 'Not implemented'
        }
    });
};

/**
 * Get connected account details by ID
 * Retrieves comprehensive details of a connected account, including authentication configuration, connection status, and all parameters needed for API requests.
 * @param data The data for the request.
 * @param data.nanoid The unique identifier (nanoid) of the connected account
 * @returns unknown Successfully retrieved connected account details with all authentication parameters and connection status
 * @throws ApiError
 */
export const getConnectedAccountsByNanoid = (data: GetConnectedAccountsByNanoidData): CancelablePromise<GetConnectedAccountsByNanoidResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/connected_accounts/{nanoid}',
        path: {
            nanoid: data.nanoid
        },
        errors: {
            400: 'Bad request - Invalid nanoid format or other validation error',
            401: 'Unauthorized - Authentication failed',
            403: 'Forbidden - Insufficient permissions to access this connected account',
            404: 'Not found - Connected account does not exist or was deleted',
            500: 'Internal server error - Failed to retrieve connected account details',
            501: 'Not implemented - This operation is not supported for the requested connected account or authentication scheme'
        }
    });
};

/**
 * Delete a connected account
 * Soft-deletes a connected account by marking it as deleted in the database. This prevents the account from being used for API calls but preserves the record for audit purposes.
 * @param data The data for the request.
 * @param data.nanoid The unique identifier (nanoid) of the connected account
 * @returns unknown Successfully deleted the connected account. The account is marked as deleted but retained in the database for historical purposes.
 * @throws ApiError
 */
export const deleteConnectedAccountsByNanoid = (data: DeleteConnectedAccountsByNanoidData): CancelablePromise<DeleteConnectedAccountsByNanoidResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/connected_accounts/{nanoid}',
        path: {
            nanoid: data.nanoid
        },
        errors: {
            400: 'Bad request - Invalid nanoid format or other validation error',
            401: 'Unauthorized - Authentication failed',
            403: 'Forbidden - Insufficient permissions to delete this connected account',
            404: 'Connected account not found - The specified account does not exist or has already been deleted',
            500: 'Internal server error - Failed to delete the connected account due to a server-side issue'
        }
    });
};

/**
 * Enable or disable a connected account
 * Updates the status of a connected account to either enabled (active) or disabled (inactive). Disabled accounts cannot be used for API calls but remain in the database.
 * @param data The data for the request.
 * @param data.nanoId The unique identifier of the connected account
 * @param data.requestBody
 * @returns unknown Successfully updated the connected account status. If enabled=true, the account status is set to ACTIVE; if enabled=false, the status is set to INACTIVE.
 * @throws ApiError
 */
export const patchConnectedAccountsByNanoIdStatus = (data: PatchConnectedAccountsByNanoIdStatusData): CancelablePromise<PatchConnectedAccountsByNanoIdStatusResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v3/connected_accounts/{nanoId}/status',
        path: {
            nanoId: data.nanoId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request - Invalid nanoid format or invalid request body',
            401: 'Unauthorized - Authentication failed',
            403: 'Forbidden - Insufficient permissions to update this connected account',
            404: 'Connected account not found - The specified account does not exist or has been deleted',
            500: 'Internal server error - Failed to update the connected account status due to a server-side issue'
        }
    });
};

/**
 * Refresh authentication for a connected account
 * Initiates a new authentication flow for a connected account when credentials have expired or become invalid. This may generate a new authentication URL for OAuth flows or refresh tokens for other auth schemes.
 * @param data The data for the request.
 * @param data.nanoid The unique identifier of the connected account
 * @param data.redirectUrl
 * @param data.requestBody
 * @returns unknown Successfully refreshed the connected account authentication. For OAuth flows, a new redirect URL is provided.
 * @throws ApiError
 */
export const postConnectedAccountsByNanoidRefresh = (data: PostConnectedAccountsByNanoidRefreshData): CancelablePromise<PostConnectedAccountsByNanoidRefreshResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/connected_accounts/{nanoid}/refresh',
        path: {
            nanoid: data.nanoid
        },
        query: {
            redirect_url: data.redirectUrl
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request - Invalid nanoid format or the account cannot be refreshed in its current state',
            401: 'Unauthorized - Authentication failed',
            403: 'Forbidden - Insufficient permissions to refresh this connected account',
            404: 'Not found - Connected account does not exist or was deleted',
            500: 'Internal server error - Failed to refresh the connected account authentication',
            501: 'Not implemented - This operation is not supported for the requested connected account or authentication scheme'
        }
    });
};

/**
 * Search and retrieve trigger event logs
 * Search and retrieve trigger event logs with advanced filtering capabilities including search parameters
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully retrieved trigger logs
 * @throws ApiError
 */
export const postInternalTriggerLogs = (data: PostInternalTriggerLogsData = {}): CancelablePromise<PostInternalTriggerLogsResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/internal/trigger/logs',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Search and retrieve action execution logs
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully retrieved action execution fields
 * @throws ApiError
 */
export const postInternalActionExecutionLogs = (data: PostInternalActionExecutionLogsData = {}): CancelablePromise<PostInternalActionExecutionLogsResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/internal/action_execution/logs',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Get action log fields for filtering
 * @returns unknown Successfully retrieved action execution fields
 * @throws ApiError
 */
export const getInternalActionExecutionFields = (): CancelablePromise<GetInternalActionExecutionFieldsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/internal/action_execution/fields'
    });
};

/**
 * Get detailed execution log by ID
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Successfully retrieved action execution log
 * @throws ApiError
 */
export const getInternalActionExecutionLogById = (data: GetInternalActionExecutionLogByIdData): CancelablePromise<GetInternalActionExecutionLogByIdResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/internal/action_execution/log/{id}',
        path: {
            id: data.id
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * List all OpenAPI specifications
 * Retrieves all OpenAPI specifications associated with the authenticated project. This endpoint returns comprehensive information about each specification, including its creation date, status, and processing logs.
 * @returns unknown Successfully fetched OpenAPI specifications
 * @throws ApiError
 */
export const getOpenapiSpecsList = (): CancelablePromise<GetOpenapiSpecsListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/openapi/specs/list',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Create a new OpenAPI specification
 * Uploads and processes a new OpenAPI specification. The processing happens asynchronously, and a job ID is returned to track the progress. Use the status endpoint to check the processing status with the job ID.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully created OpenAPI spec
 * @throws ApiError
 */
export const postOpenapiSpecsCreate = (data: PostOpenapiSpecsCreateData = {}): CancelablePromise<PostOpenapiSpecsCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/openapi/specs/create',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Not found',
            409: 'Conflict',
            500: 'Internal server error'
        }
    });
};

/**
 * Delete an OpenAPI specification by ID
 * Permanently removes an OpenAPI specification from the system. This action cannot be undone. Use this endpoint when you no longer need a particular API specification in your project.
 * @param data The data for the request.
 * @param data.id The unique identifier of the OpenAPI specification to delete. This ID is returned when creating a new specification.
 * @returns unknown Successfully deleted OpenAPI specification
 * @throws ApiError
 */
export const deleteOpenapiSpecsById = (data: DeleteOpenapiSpecsByIdData): CancelablePromise<DeleteOpenapiSpecsByIdResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/openapi/specs/{id}',
        path: {
            id: data.id
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Pipeline not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Get the status of an OpenAPI specification by ID
 * Retrieves the current processing status of an OpenAPI specification. This endpoint is useful for tracking the progress of asynchronous specification processing, especially after creating a new specification.
 * @param data The data for the request.
 * @param data.id The unique identifier of the OpenAPI specification or job ID to check status for. This ID is returned when creating a new specification.
 * @returns unknown Successfully retrieved OpenAPI spec status
 * @throws ApiError
 */
export const getOpenapiSpecsStatusById = (data: GetOpenapiSpecsStatusByIdData): CancelablePromise<GetOpenapiSpecsStatusByIdResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/openapi/specs/status/{id}',
        path: {
            id: data.id
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Get organization API key
 * Retrieve the API key for the current organization. This endpoint is restricted to organization administrators only. The returned API key can be used for authenticating organization-level API requests.
 * @returns unknown Successfully retrieved API key
 * @throws ApiError
 */
export const getOrgApiKey = (): CancelablePromise<GetOrgApiKeyResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/org/api_key',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized. Only admins can retrieve the organization API key.',
            404: 'Organization not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Regenerate organization API key
 * Generate a new API key for the organization, invalidating the previous one (admin only). This operation cannot be undone and will immediately invalidate the previous API key.
 * @returns unknown API key regenerated successfully
 * @throws ApiError
 */
export const postOrgApiKeyRegenerate = (): CancelablePromise<PostOrgApiKeyRegenerateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/org/api_key/regenerate',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized. Only admins can regenerate API keys.',
            404: 'Organization not found',
            500: 'Internal server error'
        }
    });
};

/**
 * List all projects
 * Retrieves all projects belonging to the authenticated user's organization. Projects are returned in descending order of creation date (newest first). This endpoint is useful for displaying project selection in dashboards or for integrations that need to list all available projects.
 * @returns unknown Projects retrieved successfully. Returns an array of project objects with their complete details including webhook URLs, creation dates, and configuration.
 * @throws ApiError
 */
export const getOrgProjectList = (): CancelablePromise<GetOrgProjectListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/org/project/list',
        errors: {
            400: 'Bad request. This may occur if there are invalid query parameters or the request is malformed.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Create a new project
 * Creates a new project within the authenticated user's organization using the specified name. Projects are isolated environments within your organization, each with their own API keys, webhook configurations, and resources. Use this endpoint to create additional projects for different environments (e.g., development, staging, production) or for separate applications.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Project successfully created. Returns the complete project object with generated IDs, webhook secrets, and configuration.
 * @throws ApiError
 */
export const postOrgProjectNew = (data: PostOrgProjectNewData = {}): CancelablePromise<PostOrgProjectNewResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/org/project/new',
        body: data.requestBody,
        mediaType: 'application/json',
        responseTransformer: PostOrgProjectNewResponseTransformer,
        errors: {
            400: 'Bad request. This may occur if the project name format is invalid, too short, or contains invalid characters.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            409: 'Conflict. A project with the same name already exists in this organization.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Delete a project
 * Soft-deletes a project within the organization by its unique identifier. When a project is deleted, it is marked as deleted but not immediately removed from the database. This operation affects all resources associated with the project including API keys, webhook configurations, and connected services. This action cannot be undone through the API.
 * @param data The data for the request.
 * @param data.projectId Unique identifier (Nano ID) of the project to delete
 * @returns unknown Project successfully deleted. The project has been marked as deleted in the system.
 * @throws ApiError
 */
export const deleteOrgProjectDeleteByProjectId = (data: DeleteOrgProjectDeleteByProjectIdData): CancelablePromise<DeleteOrgProjectDeleteByProjectIdResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/org/project/delete/{projectId}',
        path: {
            projectId: data.projectId
        },
        errors: {
            400: 'Bad request. The project ID may be invalid or in an incorrect format.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            403: 'Forbidden. You do not have permission to delete this project.',
            404: 'Project not found. The specified project does not exist or has already been deleted.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Get project details by ID
 * Retrieves detailed information about a specific project using its unique identifier. This endpoint provides complete project configuration including webhook URLs, creation and update timestamps, and webhook secrets. Use this endpoint to inspect project settings or verify project configuration.
 * @param data The data for the request.
 * @param data.projectId Unique identifier (Nano ID) of the project to retrieve
 * @returns unknown Project retrieved successfully. Returns a complete project object with all configuration details.
 * @throws ApiError
 */
export const getOrgProjectByProjectId = (data: GetOrgProjectByProjectIdData): CancelablePromise<GetOrgProjectByProjectIdResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/org/project/{projectId}',
        path: {
            projectId: data.projectId
        },
        responseTransformer: GetOrgProjectByProjectIdResponseTransformer,
        errors: {
            400: 'Bad request. This may occur if the project ID format is invalid.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            404: 'Project not found. The specified project ID does not exist or belongs to a different organization.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * List project API keys
 * Retrieves all API keys associated with the specified project. This endpoint returns details about each API key including its name, creation date, and last used information. Use this endpoint to audit which keys exist for a project or to manage key rotation policies.
 * @param data The data for the request.
 * @param data.projectId Unique identifier (Nano ID) of the project to retrieve API keys for
 * @returns unknown Successfully retrieved the list of API keys for the specified project
 * @throws ApiError
 */
export const getOrgProjectByProjectIdApiKeysList = (data: GetOrgProjectByProjectIdApiKeysListData): CancelablePromise<GetOrgProjectByProjectIdApiKeysListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/org/project/{projectId}/api_keys/list',
        path: {
            projectId: data.projectId
        },
        errors: {
            400: 'Bad request. This may occur if the project ID format is invalid.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            404: 'API Keys not found. Either the project does not exist or it has no API keys configured.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Create project API key
 * Creates a new API key for the specified project. API keys are used for authenticating requests to the API. This endpoint generates a new key with the provided name and returns the complete key details including the actual key value. Note that the full API key value is only returned once at creation time and cannot be retrieved later, so it should be securely stored immediately.
 * @param data The data for the request.
 * @param data.projectId Unique identifier (Nano ID) of the project to create an API key for
 * @param data.requestBody
 * @returns unknown API key created successfully. The response includes the full API key value that should be stored securely, as it cannot be retrieved again later.
 * @throws ApiError
 */
export const postOrgProjectByProjectIdApiKeysCreate = (data: PostOrgProjectByProjectIdApiKeysCreateData): CancelablePromise<PostOrgProjectByProjectIdApiKeysCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/org/project/{projectId}/api_keys/create',
        path: {
            projectId: data.projectId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        responseTransformer: PostOrgProjectByProjectIdApiKeysCreateResponseTransformer,
        errors: {
            400: 'Bad request. This may occur if the request body is invalid or missing required fields.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            404: 'Project not found. The specified project does not exist or belongs to a different organization.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Get or create project API key
 * Retrieves an existing API key for the project or creates a new one if none exists. This endpoint is useful for ensuring a project always has at least one API key without the risk of creating duplicates. If an API key already exists, it returns the existing key. If no API keys exist for the project, it creates a new one with an automatically generated name.
 * @param data The data for the request.
 * @param data.projectId Unique identifier (Nano ID) of the project to get or create an API key for
 * @returns unknown Returned an existing API key. The project already had at least one API key, so no new key was created.
 * @returns unknown API key created successfully. A new API key was created because the project did not have any existing keys.
 * @throws ApiError
 */
export const postOrgProjectByProjectIdApiKeysCreateApiKey = (data: PostOrgProjectByProjectIdApiKeysCreateApiKeyData): CancelablePromise<PostOrgProjectByProjectIdApiKeysCreateApiKeyResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/org/project/{projectId}/api_keys/create-api-key',
        path: {
            projectId: data.projectId
        },
        errors: {
            400: 'Bad request. This may occur if the project ID format is invalid.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            404: 'Project not found. The specified project does not exist or belongs to a different organization.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Delete project API key
 * Permanently deletes an API key from the specified project. Once deleted, the API key can no longer be used for authentication and any services using it will need to be updated with a new key. This operation cannot be undone, so it should be used with caution.
 * @param data The data for the request.
 * @param data.id Unique identifier of the API key to delete
 * @param data.projectId Unique identifier (Nano ID) of the project containing the API key
 * @returns unknown API key deleted successfully. Any services using this key will need to be updated.
 * @throws ApiError
 */
export const deleteOrgProjectByProjectIdApiKeysRemoveById = (data: DeleteOrgProjectByProjectIdApiKeysRemoveByIdData): CancelablePromise<DeleteOrgProjectByProjectIdApiKeysRemoveByIdResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/org/project/{projectId}/api_keys/remove/{id}',
        path: {
            id: data.id,
            projectId: data.projectId
        },
        errors: {
            400: 'Bad request. This may occur if the API key ID or project ID format is invalid.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            404: 'API key not found. The specified API key ID does not exist in the given project.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Get webhook URL and secret
 * Retrieves the webhook URL and secret for the current project. Webhooks come in two types: "trigger" webhooks are used for integration trigger events, while "event" webhooks receive system notifications about project events. The response includes both the URL and the secret key used to verify webhook signatures.
 * @param data The data for the request.
 * @param data.type Type of webhook to retrieve (trigger or event)
 * @returns unknown Webhook URL and secret retrieved successfully. Use the URL to receive events and the secret to verify incoming webhook signatures.
 * @throws ApiError
 */
export const getOrgProjectWebhook = (data: GetOrgProjectWebhookData): CancelablePromise<GetOrgProjectWebhookResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/org/project/webhook',
        query: {
            type: data.type
        },
        errors: {
            400: 'Bad request. The webhook type may be invalid or missing.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            404: 'Project not found. The specified project does not exist or has been deleted.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Delete project webhook URL
 * Removes a webhook URL (trigger or event) from the project configuration. This operation sets the specified webhook URL to null in the database but preserves the webhook secret. After deletion, the project will no longer receive webhook notifications of the specified type until a new URL is configured.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Webhook URL deleted successfully. The project will no longer receive webhook notifications of the specified type.
 * @throws ApiError
 */
export const deleteOrgProjectWebhook = (data: DeleteOrgProjectWebhookData = {}): CancelablePromise<DeleteOrgProjectWebhookResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/org/project/webhook',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request. The webhook type may be invalid or missing from the request body.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            404: 'Project not found. The specified project does not exist or has been deleted.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Update project webhook URL
 * Updates the webhook URL for the current project based on the specified type (trigger or event). Webhook URLs are endpoints that receive notifications about events in your project. "Trigger" webhooks receive integration trigger events, while "event" webhooks receive system notifications. This endpoint allows you to set or change these notification destinations.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Webhook URL updated successfully. The project will now send notifications to the new URL.
 * @throws ApiError
 */
export const postOrgProjectWebhookUpdate = (data: PostOrgProjectWebhookUpdateData = {}): CancelablePromise<PostOrgProjectWebhookUpdateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/org/project/webhook/update',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request. The webhook URL may be invalid or the webhook type is incorrect.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            404: 'Project not found. The specified project does not exist or has been deleted.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Refresh webhook secret
 * Generates a new webhook secret for the project, invalidating the previous one. Webhook secrets are used to verify the authenticity of incoming webhook payloads through signature verification. This endpoint should be used when you need to rotate your webhook secret for security purposes. After refreshing, you must update your webhook verification logic to use the new secret.
 * @returns unknown Webhook secret refreshed successfully. The new secret is returned in the response and should be used for webhook signature verification.
 * @throws ApiError
 */
export const postOrgProjectWebhookRefresh = (): CancelablePromise<PostOrgProjectWebhookRefreshResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/org/project/webhook/refresh',
        errors: {
            400: 'Bad request. This may occur if the request is malformed.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            404: 'Project not found. The specified project does not exist or has been deleted.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * List team members
 * Retrieve a list of all team members in the current organization
 * @returns unknown Successfully retrieved team members
 * @throws ApiError
 */
export const getTeamMembersList = (): CancelablePromise<GetTeamMembersListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/team-members/list',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Invite team member
 * Send an invitation to a new team member to join the organization
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Team member invited successfully
 * @throws ApiError
 */
export const postTeamMembersInvite = (data: PostTeamMembersInviteData = {}): CancelablePromise<PostTeamMembersInviteResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/team-members/invite',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Invalid request',
            401: 'Unauthorized',
            404: 'Org not found',
            409: 'Member already exists',
            500: 'Internal server error'
        }
    });
};

/**
 * Remove team member
 * Remove a team member from the organization and revoke their access
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Team member removed successfully
 * @throws ApiError
 */
export const deleteTeamMembersRemoveById = (data: DeleteTeamMembersRemoveByIdData): CancelablePromise<DeleteTeamMembersRemoveByIdResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/team-members/remove/{id}',
        path: {
            id: data.id
        },
        errors: {
            400: 'Invalid request',
            401: 'Unauthorized',
            404: 'Not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Update team member
 * Update the details of an existing team member
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown Team member updated successfully
 * @throws ApiError
 */
export const putTeamMembersUpdateById = (data: PutTeamMembersUpdateByIdData): CancelablePromise<PutTeamMembersUpdateByIdResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/v3/team-members/update/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Member not found',
            500: 'Internal server error'
        }
    });
};

/**
 * List available toolkits
 * Retrieves a comprehensive list of toolkits that are available to the authenticated project. Toolkits represent integration points with external services and applications, each containing a collection of tools and triggers. This endpoint supports filtering by category, management type, and local availability, as well as different sorting options.
 * @param data The data for the request.
 * @param data.category Filter toolkits by category
 * @param data.managedBy Filter toolkits by who manages them
 * @param data.isLocal Whether to include local toolkits in the results
 * @param data.sortBy Sort order for returned toolkits
 * @param data.limit Number of items per page
 * @param data.cursor Cursor for pagination. The cursor is a base64 encoded string of the page and limit. The page is the page number and the limit is the number of items per page. The cursor is used to paginate through the items. The cursor is not required for the first page.
 * @returns unknown Toolkits retrieved successfully. Returns a paginated list of available toolkits with detailed metadata.
 * @throws ApiError
 */
export const getToolkits = (data: GetToolkitsData = {}): CancelablePromise<GetToolkitsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/toolkits',
        query: {
            category: data.category,
            managed_by: data.managedBy,
            is_local: data.isLocal,
            sort_by: data.sortBy,
            limit: data.limit,
            cursor: data.cursor
        },
        errors: {
            400: 'Bad request. The query parameters may be invalid or in an incorrect format.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            403: 'Forbidden. The authenticated user does not have permission to list toolkits for this project.',
            404: 'Not found. The toolkits you are looking for do not exist.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * List toolkit categories
 * Retrieves a comprehensive list of all available toolkit categories. These categories can be used to filter toolkits by type or purpose when using the toolkit listing endpoint. Categories help organize toolkits into logical groups based on their functionality or industry focus.
 * @param data The data for the request.
 * @param data.cache Cache control parameter
 * @returns unknown Successfully retrieved a paginated list of all available toolkit categories with their identifiers and display names.
 * @throws ApiError
 */
export const getToolkitsCategories = (data: GetToolkitsCategoriesData = {}): CancelablePromise<GetToolkitsCategoriesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/toolkits/categories',
        query: {
            cache: data.cache
        },
        errors: {
            400: 'Bad request. The query parameters may be invalid or in an incorrect format.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            404: 'Not found. The requested resource was not found.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Get toolkit by slug
 * Retrieves comprehensive information about a specific toolkit using its unique slug identifier. This endpoint provides detailed metadata, authentication configuration options, and feature counts for the requested toolkit.
 * @param data The data for the request.
 * @param data.slug Toolkit slug identifier
 * @returns unknown Successfully retrieved detailed information about the requested toolkit, including authentication options, metadata, and feature counts.
 * @throws ApiError
 */
export const getToolkitsBySlug = (data: GetToolkitsBySlugData): CancelablePromise<GetToolkitsBySlugResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/toolkits/{slug}',
        path: {
            slug: data.slug
        },
        errors: {
            400: 'Bad request. The toolkit slug may be invalid or in an incorrect format.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            404: 'Not found. The requested toolkit does not exist or is not accessible to the authenticated project.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * List available tools
 * Retrieve a paginated list of available tools with comprehensive filtering, sorting and search capabilities. Use query parameters to narrow down results by toolkit, tags, or search terms.
 * @param data The data for the request.
 * @param data.toolkitSlug The slug of the toolkit to filter by
 * @param data.toolSlugs Comma-separated list of specific tool slugs to retrieve (overrides other filters)
 * @param data.authConfigIds
 * @param data.important Filter to only show important/featured tools (set to "true" to enable)
 * @param data.tags Filter tools by one or more tags (can be specified multiple times)
 * @param data.scopes Array of scopes to filter tools by)
 * @param data.search Free-text search query to find tools by name, description, or functionality
 * @param data.limit Number of items per page
 * @param data.cursor Cursor for pagination. The cursor is a base64 encoded string of the page and limit. The page is the page number and the limit is the number of items per page. The cursor is used to paginate through the items. The cursor is not required for the first page.
 * @returns ToolsPaginated Successfully retrieved tools list with pagination information
 * @throws ApiError
 */
export const getTools = (data: GetToolsData = {}): CancelablePromise<GetToolsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/tools',
        query: {
            toolkit_slug: data.toolkitSlug,
            tool_slugs: data.toolSlugs,
            auth_config_ids: data.authConfigIds,
            important: data.important,
            tags: data.tags,
            scopes: data.scopes,
            search: data.search,
            limit: data.limit,
            cursor: data.cursor
        },
        errors: {
            400: 'Bad request - Invalid query parameters',
            401: 'Unauthorized - Authentication credentials are missing or invalid',
            403: 'Forbidden - User does not have permission to access tools',
            404: 'Not found - The requested resource was not found',
            429: 'Too many requests - Rate limit exceeded',
            500: 'Internal server error - Something went wrong on the server'
        }
    });
};

/**
 * Get tool enum list
 * Retrieve a list of all available tool enumeration values (tool slugs) for the project. This endpoint returns a comma-separated string of tool slugs that can be used in other API calls.
 * @returns string Successfully retrieved tool enum list
 * @throws ApiError
 */
export const getToolsEnum = (): CancelablePromise<GetToolsEnumResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/tools/enum',
        errors: {
            400: 'Bad request - Invalid request parameters',
            401: 'Unauthorized - Authentication credentials are missing or invalid',
            403: 'Forbidden - User does not have permission to access tool enums',
            404: 'Not found - Tool enum list not found',
            500: 'Internal server error - Something went wrong on the server'
        }
    });
};

/**
 * Get tool by slug
 * Retrieve detailed information about a specific tool using its slug identifier. This endpoint returns full metadata about a tool including input/output parameters, versions, and toolkit information.
 * @param data The data for the request.
 * @param data.toolSlug The unique slug identifier of the tool
 * @returns Tool Successfully retrieved tool details
 * @throws ApiError
 */
export const getToolsByToolSlug = (data: GetToolsByToolSlugData): CancelablePromise<GetToolsByToolSlugResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/tools/{tool_slug}',
        path: {
            tool_slug: data.toolSlug
        },
        errors: {
            400: 'Bad request - Invalid tool slug format',
            401: 'Unauthorized - Authentication credentials are missing or invalid',
            404: 'Not found - Tool with the specified slug does not exist',
            500: 'Internal server error - Something went wrong on the server'
        }
    });
};

/**
 * Execute tool
 * Execute a specific tool operation with provided arguments and authentication. This is the primary endpoint for integrating with third-party services and executing tools. You can provide structured arguments or use natural language processing by providing a text description of what you want to accomplish.
 * @param data The data for the request.
 * @param data.toolSlug The tool slug to execute
 * @param data.requestBody
 * @returns unknown Successfully executed action and received response
 * @throws ApiError
 */
export const postToolsExecuteByToolSlug = (data: PostToolsExecuteByToolSlugData): CancelablePromise<PostToolsExecuteByToolSlugResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/tools/execute/{tool_slug}',
        path: {
            tool_slug: data.toolSlug
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request - Invalid request parameters, missing required arguments, or conflicting parameters',
            401: 'Unauthorized - Authentication credentials are missing or invalid',
            403: 'Forbidden - Connected account does not have permission to execute this tool or access the requested resource',
            404: 'Not found - Tool or connected account not found',
            410: 'Gone - Tool has been deprecated and is no longer available',
            422: 'Unprocessable entity - Invalid state of the connected account',
            429: 'Rate limit exceeded - Too many requests to the tool or underlying API',
            500: 'Internal server error - Something went wrong on the server',
            501: 'Not implemented',
            502: 'Bad gateway - Error communicating with the tool provider API',
            503: 'Upstream service unavailable - Tool provider API is currently down or unavailable'
        }
    });
};

/**
 * Generate tool inputs from natural language
 * Uses AI to translate a natural language description into structured arguments for a specific tool. This endpoint is useful when you want to let users describe what they want to do in plain language instead of providing structured parameters.
 * @param data The data for the request.
 * @param data.toolSlug The tool slug to generate inputs for
 * @param data.requestBody
 * @returns unknown Successfully generated structured inputs for the action based on natural language description
 * @throws ApiError
 */
export const postToolsExecuteByToolSlugInput = (data: PostToolsExecuteByToolSlugInputData): CancelablePromise<PostToolsExecuteByToolSlugInputResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/tools/execute/{tool_slug}/input',
        path: {
            tool_slug: data.toolSlug
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request - Invalid input parameters or insufficient description to generate tool arguments',
            401: 'Unauthorized - Authentication credentials are missing or invalid',
            404: 'Not found - The specified tool does not exist',
            422: 'Unprocessable entity - Invalid state of the connected account',
            429: 'Too many requests - Rate limit exceeded for natural language processing',
            500: 'Internal server error - AI processing failed or other server error occurred'
        }
    });
};

/**
 * Execute proxy request
 * Proxy an HTTP request to a third-party API using connected account credentials. This endpoint allows making authenticated API calls to external services while abstracting away authentication details.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully executed proxy request and received response
 * @throws ApiError
 */
export const postToolsExecuteProxy = (data: PostToolsExecuteProxyData = {}): CancelablePromise<PostToolsExecuteProxyResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/tools/execute/proxy',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request - Invalid request parameters or body format',
            401: 'Unauthorized - Authentication credentials are missing or invalid',
            403: 'Forbidden - Connected account does not have permission to access the requested resource',
            404: 'Not found - Resource not found or connected account not found',
            422: 'Unprocessable entity - Invalid state of the connected account',
            429: 'Too many requests - Rate limit exceeded on the connected account or proxy service',
            500: 'Internal server error - Something went wrong on the server',
            501: 'Not implemented - This operation is not supported for the requested connected account or authentication scheme',
            502: 'Bad gateway - Error communicating with the upstream API',
            504: 'Gateway timeout - Upstream API timed out'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.slug The slug of the trigger instance
 * @param data.projectId
 * @returns string ok
 * @throws ApiError
 */
export const getTriggerInstancesBySlugByProjectIdHandle = (data: GetTriggerInstancesBySlugByProjectIdHandleData): CancelablePromise<GetTriggerInstancesBySlugByProjectIdHandleResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/trigger_instances/{slug}/{projectId}/handle',
        path: {
            slug: data.slug,
            projectId: data.projectId
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            410: 'Gone',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.slug The slug of the trigger instance
 * @param data.projectId
 * @returns string ok
 * @throws ApiError
 */
export const postTriggerInstancesBySlugByProjectIdHandle = (data: PostTriggerInstancesBySlugByProjectIdHandleData): CancelablePromise<PostTriggerInstancesBySlugByProjectIdHandleResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/trigger_instances/{slug}/{projectId}/handle',
        path: {
            slug: data.slug,
            projectId: data.projectId
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            410: 'Gone',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.slug The slug of the trigger instance
 * @param data.projectId
 * @returns string ok
 * @throws ApiError
 */
export const headTriggerInstancesBySlugByProjectIdHandle = (data: HeadTriggerInstancesBySlugByProjectIdHandleData): CancelablePromise<HeadTriggerInstancesBySlugByProjectIdHandleResponse> => {
    return __request(OpenAPI, {
        method: 'HEAD',
        url: '/api/v3/trigger_instances/{slug}/{projectId}/handle',
        path: {
            slug: data.slug,
            projectId: data.projectId
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            410: 'Gone',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.slug The slug of the trigger instance
 * @param data.requestBody
 * @returns unknown Successfully updated trigger instance
 * @returns unknown No content
 * @throws ApiError
 */
export const postTriggerInstancesBySlugUpsert = (data: PostTriggerInstancesBySlugUpsertData): CancelablePromise<PostTriggerInstancesBySlugUpsertResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/trigger_instances/{slug}/upsert',
        path: {
            slug: data.slug
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Trigger instance not found',
            500: 'Internal server error',
            501: 'Not implemented'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.connectedAccountIds Array of connected account IDs to filter triggers by
 * @param data.authConfigIds Array of auth config IDs to filter triggers by
 * @param data.triggerIds Array of trigger IDs to filter triggers by
 * @param data.triggerNames Array of trigger names to filter triggers by
 * @param data.connectedAccountIds
 * @param data.authConfigIds
 * @param data.triggerIds
 * @param data.showDisabled When set to true, includes disabled triggers in the response.
 * @param data.triggerNames
 * @param data.page Page number for pagination. Starts from 1.
 * @param data.showDisabled
 * @param data.deprecatedConnectedAccountUuids Array of connected account UUIDs to filter triggers by
 * @param data.deprecatedAuthConfigUuids Array of auth config UUIDs to filter triggers by
 * @param data.limit Number of items per page
 * @param data.cursor Cursor for pagination. The cursor is a base64 encoded string of the page and limit. The page is the page number and the limit is the number of items per page. The cursor is used to paginate through the items. The cursor is not required for the first page.
 * @returns unknown Successfully retrieved active trigger instances
 * @throws ApiError
 */
export const getTriggerInstancesActive = (data: GetTriggerInstancesActiveData = {}): CancelablePromise<GetTriggerInstancesActiveResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/trigger_instances/active',
        query: {
            connected_account_ids: data.connectedAccountIds,
            auth_config_ids: data.authConfigIds,
            trigger_ids: data.triggerIds,
            trigger_names: data.triggerNames,
            connectedAccountIds: data.connectedAccountIds,
            authConfigIds: data.authConfigIds,
            triggerIds: data.triggerIds,
            show_disabled: data.showDisabled,
            triggerNames: data.triggerNames,
            page: data.page,
            showDisabled: data.showDisabled,
            deprecatedConnectedAccountUuids: data.deprecatedConnectedAccountUuids,
            deprecatedAuthConfigUuids: data.deprecatedAuthConfigUuids,
            limit: data.limit,
            cursor: data.cursor
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.triggerId The ID of the trigger instance to delete
 * @returns unknown Successfully deleted the trigger instance
 * @throws ApiError
 */
export const deleteTriggerInstancesManageByTriggerId = (data: DeleteTriggerInstancesManageByTriggerIdData): CancelablePromise<DeleteTriggerInstancesManageByTriggerIdResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/trigger_instances/manage/{triggerId}',
        path: {
            triggerId: data.triggerId
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Trigger instance not found',
            409: 'Trigger instance already deleted',
            410: 'Trigger instance already gone',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.triggerId The ID of the trigger instance to update
 * @param data.requestBody
 * @returns unknown Successfully updated trigger status
 * @throws ApiError
 */
export const patchTriggerInstancesManageByTriggerId = (data: PatchTriggerInstancesManageByTriggerIdData): CancelablePromise<PatchTriggerInstancesManageByTriggerIdResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v3/trigger_instances/manage/{triggerId}',
        path: {
            triggerId: data.triggerId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad Request',
            401: 'Unauthorized',
            404: 'Trigger instance not found',
            410: 'Trigger instance already gone',
            500: 'Internal Server Error',
            501: 'Not implemented'
        }
    });
};

/**
 * List trigger type enums
 * Retrieves a list of all available trigger type enum values that can be used across the API
 * @returns string Successfully retrieved trigger enum list
 * @throws ApiError
 */
export const getTriggersTypesListEnum = (): CancelablePromise<GetTriggersTypesListEnumResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/triggers_types/list/enum',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Get trigger type by slug
 * Retrieve detailed information about a specific trigger type using its slug identifier
 * @param data The data for the request.
 * @param data.slug The unique slug identifier for the trigger type
 * @returns unknown Successfully retrieved trigger type
 * @throws ApiError
 */
export const getTriggersTypesBySlug = (data: GetTriggersTypesBySlugData): CancelablePromise<GetTriggersTypesBySlugResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/triggers_types/{slug}',
        path: {
            slug: data.slug
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Not found',
            500: 'Internal server error'
        }
    });
};

/**
 * List trigger types
 * Retrieve a list of available trigger types with optional filtering by toolkit. Results are paginated and can be filtered by toolkit.
 * @param data The data for the request.
 * @param data.toolkitSlugs Array of toolkit slugs to filter triggers by
 * @param data.limit Number of items per page
 * @param data.cursor Cursor for pagination. The cursor is a base64 encoded string of the page and limit. The page is the page number and the limit is the number of items per page. The cursor is used to paginate through the items. The cursor is not required for the first page.
 * @returns unknown Successfully retrieved triggers
 * @throws ApiError
 */
export const getTriggersTypes = (data: GetTriggersTypesData = {}): CancelablePromise<GetTriggersTypesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/triggers_types',
        query: {
            toolkit_slugs: data.toolkitSlugs,
            limit: data.limit,
            cursor: data.cursor
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Get project trigger status
 * Retrieves the current project details including its trigger enablement status. Use this endpoint to check whether triggers are currently enabled or disabled for a project.
 * @returns unknown Project retrieved successfully with trigger status information
 * @throws ApiError
 */
export const getOrgProjectTrigger = (): CancelablePromise<GetOrgProjectTriggerResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/org/project/trigger',
        responseTransformer: GetOrgProjectTriggerResponseTransformer,
        errors: {
            400: 'Bad request. This may occur if the request is malformed.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            404: 'Project not found. The specified project ID does not exist or belongs to a different organization.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Update project trigger status
 * Updates the trigger enablement status for the current project. Use this endpoint to enable or disable triggers for automated workflows within a project.
 * @param data The data for the request.
 * @param data.enabled Boolean flag indicating whether triggers should be enabled (true) or disabled (false) for the project
 * @returns unknown Project trigger status successfully updated. Returns the complete project object with the updated trigger status.
 * @throws ApiError
 */
export const patchOrgProjectTrigger = (data: PatchOrgProjectTriggerData = {}): CancelablePromise<PatchOrgProjectTriggerResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v3/org/project/trigger',
        query: {
            enabled: data.enabled
        },
        responseTransformer: PatchOrgProjectTriggerResponseTransformer,
        errors: {
            400: 'Bad request. This may occur if the request is malformed or invalid parameters are provided.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            404: 'Project not found. The specified project does not exist or belongs to a different organization.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Payment link created successfully
 * @throws ApiError
 */
export const postPaymentsSession = (data: PostPaymentsSessionData = {}): CancelablePromise<PostPaymentsSessionResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/payments/session',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Billing portal session created successfully
 * @throws ApiError
 */
export const postPaymentsManageSubscription = (data: PostPaymentsManageSubscriptionData = {}): CancelablePromise<PostPaymentsManageSubscriptionResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/payments/manage-subscription',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Create a Stripe payment link
 * Generates a payment link that redirects to Stripe checkout for processing a one-time payment. This endpoint finds or creates a Stripe customer based on email and associates the payment with the correct organization.
 * @param data The data for the request.
 * @param data.amount Payment amount in cents (smallest currency unit)
 * @param data.email Customer email address for the payment and receipt
 * @param data.description Description of the payment that will appear on the invoice and Stripe dashboard
 * @returns unknown Payment link created successfully with URL and session information
 * @throws ApiError
 */
export const getAdminCreatePaymentLink = (data: GetAdminCreatePaymentLinkData): CancelablePromise<GetAdminCreatePaymentLinkResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/admin/create-payment-link',
        query: {
            amount: data.amount,
            email: data.email,
            description: data.description
        },
        errors: {
            302: 'Redirect to Stripe payment page',
            400: 'Bad request - Invalid parameters or organization not found'
        }
    });
};

/**
 * Validate MCP server and retrieve connection details
 * Admin-only endpoint that validates a Model Control Protocol (MCP) server and retrieves its complete configuration details, including authentication information. This endpoint is typically used by the MCP service itself to authenticate and authorize connection requests from clients.
 * @param data The data for the request.
 * @param data.uuid UUID of the MCP server to validate
 * @param data.xComposioAdminToken Admin token
 * @returns unknown MCP server validated successfully. Returns the complete server configuration including authentication details, enabled applications, and available tools.
 * @throws ApiError
 */
export const getMcpValidateByUuid = (data: GetMcpValidateByUuidData): CancelablePromise<GetMcpValidateByUuidResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/mcp/validate/{uuid}',
        path: {
            uuid: data.uuid
        },
        headers: {
            'x-composio-admin-token': data.xComposioAdminToken
        },
        errors: {
            400: 'Bad request. The server ID parameter may be invalid or in an incorrect format.',
            401: 'Unauthorized. The x-composio-admin-token header is missing, invalid, or has insufficient privileges.',
            403: 'Forbidden. The provided token does not have permission to validate MCP servers.',
            404: 'MCP server not found. No server with the specified ID exists or it has been deleted.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * List MCP servers with optional filters and pagination
 * Retrieves a paginated list of MCP servers associated with the authenticated project. Results can be filtered by name, toolkit, or authentication configuration ID. MCP servers are used to provide Model Control Protocol integration points for connecting AI assistants to your applications and services.
 * @param data The data for the request.
 * @param data.name Filter MCP servers by name (case-insensitive partial match)
 * @param data.toolkits Comma-separated list of toolkit slugs to filter servers by
 * @param data.authConfigIds Comma-separated list of auth config IDs to filter servers by
 * @param data.pageNo Page number for pagination (1-based)
 * @param data.limit Number of items per page (default: 10)
 * @returns unknown Successfully retrieved MCP servers. Returns a paginated list of server configurations including connection details and command instructions.
 * @throws ApiError
 */
export const getMcpServers = (data: GetMcpServersData = {}): CancelablePromise<GetMcpServersResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/mcp/servers',
        query: {
            name: data.name,
            toolkits: data.toolkits,
            auth_config_ids: data.authConfigIds,
            page_no: data.pageNo,
            limit: data.limit
        },
        errors: {
            400: 'Bad request. The query parameters may be invalid or in an incorrect format.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            403: 'Forbidden. The authenticated user does not have permission to view MCP servers for this project.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Create a new MCP server
 * Creates a new Model Control Protocol (MCP) server instance for the authenticated project. An MCP server provides a connection point for AI assistants to access your applications and services. The server is configured with specific authentication and tool permissions that determine what actions the connected assistants can perform.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown MCP server created successfully. Returns the complete server configuration including connection details and command instructions.
 * @throws ApiError
 */
export const postMcpServers = (data: PostMcpServersData = {}): CancelablePromise<PostMcpServersResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/mcp/servers',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request. The request body may be invalid, missing required parameters, or the auth_config_id may not exist.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            403: 'Forbidden. The authenticated user does not have permission to create MCP servers for this project.',
            404: 'Not Found. The specified auth_config_id does not exist or is not accessible to the authenticated user.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Create a new custom MCP server with multiple apps
 * Creates a new Model Control Protocol (MCP) server instance that can integrate with multiple applications or toolkits simultaneously. This endpoint allows you to create a server that can access tools from different applications, making it suitable for complex workflows that span multiple services.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Custom MCP server created successfully. Returns the complete server configuration including connection details and command instructions for all specified applications.
 * @throws ApiError
 */
export const postMcpServersCustom = (data: PostMcpServersCustomData = {}): CancelablePromise<PostMcpServersCustomResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/mcp/servers/custom',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request. The request body may be invalid, missing required parameters, or contain invalid toolkit identifiers.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            403: 'Forbidden. The authenticated user does not have permission to create MCP servers for this project.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Generate MCP URL with custom parameters
 * Generates a Model Control Protocol (MCP) URL for an existing server with custom query parameters. The URL includes user-specific parameters and configuration flags that control the behavior of the MCP connection.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully generated MCP URL. Returns the complete URL with all specified query parameters.
 * @throws ApiError
 */
export const postMcpServersGenerate = (data: PostMcpServersGenerateData = {}): CancelablePromise<PostMcpServersGenerateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/mcp/servers/generate',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request. The request body may be invalid or missing required parameters.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            403: 'Forbidden. The authenticated user does not have permission to access this MCP server.',
            404: 'MCP server not found. No server with the specified ID exists or it has been deleted.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Get MCP server details by ID
 * Retrieves detailed configuration information for a specific Model Control Protocol (MCP) server. The returned data includes connection details, associated applications, enabled tools, and authentication configuration.
 * @param data The data for the request.
 * @param data.id The ID of the MCP server
 * @returns unknown Successfully retrieved MCP server. Returns the complete server configuration including connection details, authentication settings, and available tools.
 * @throws ApiError
 */
export const getMcpById = (data: GetMcpByIdData): CancelablePromise<GetMcpByIdResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/mcp/{id}',
        path: {
            id: data.id
        },
        errors: {
            400: 'Bad request. The server ID parameter may be invalid or in an incorrect format.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            403: 'Forbidden. The authenticated user does not have permission to view this MCP server.',
            404: 'MCP server not found. No server with the specified ID exists or it has been deleted.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Update MCP server configuration
 * Updates the configuration of an existing Model Control Protocol (MCP) server. You can modify the server name, associated applications, and enabled tools. Only the fields included in the request will be updated.
 * @param data The data for the request.
 * @param data.id The ID of the MCP server
 * @param data.requestBody
 * @returns unknown Successfully updated MCP server. Returns the complete updated server configuration including connection details, authentication settings, and available tools.
 * @throws ApiError
 */
export const patchMcpById = (data: PatchMcpByIdData): CancelablePromise<PatchMcpByIdResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v3/mcp/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request. The request parameters may be invalid or in an incorrect format.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            403: 'Forbidden. The authenticated user does not have permission to update this MCP server.',
            404: 'MCP server not found. No server with the specified ID exists or it has been deleted.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * Delete an MCP server
 * Performs a soft delete on a Model Control Protocol (MCP) server, making it unavailable for future use. This operation is reversible in the database but cannot be undone through the API. Any applications or services connected to this server will lose access after deletion.
 * @param data The data for the request.
 * @param data.id The ID of the MCP server
 * @returns unknown Successfully deleted MCP server. The server has been soft-deleted and is no longer available for use.
 * @throws ApiError
 */
export const deleteMcpById = (data: DeleteMcpByIdData): CancelablePromise<DeleteMcpByIdResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/mcp/{id}',
        path: {
            id: data.id
        },
        errors: {
            400: 'Bad request. The server ID parameter may be invalid or in an incorrect format.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            403: 'Forbidden. The authenticated user does not have permission to delete this MCP server.',
            404: 'MCP server not found. No server with the specified ID exists or it has already been deleted.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * List MCP servers for a specific app
 * Retrieves a paginated list of Model Control Protocol (MCP) servers that are configured for a specific application or toolkit. This endpoint allows you to find all MCP server instances that have access to a particular application, such as GitHub, Slack, or Jira.
 * @param data The data for the request.
 * @param data.appKey The key of the app to find MCP servers for
 * @param data.name Filter MCP servers by name (case-insensitive partial match)
 * @param data.toolkits Comma-separated list of toolkit slugs to filter servers by
 * @param data.authConfigIds Comma-separated list of auth config IDs to filter servers by
 * @param data.pageNo Page number for pagination (1-based)
 * @param data.limit Number of items per page (default: 10)
 * @returns unknown Successfully retrieved MCP servers for the specified application. Returns a paginated list of server configurations including connection details and command instructions.
 * @throws ApiError
 */
export const getMcpAppByAppKey = (data: GetMcpAppByAppKeyData): CancelablePromise<GetMcpAppByAppKeyResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/mcp/app/{appKey}',
        path: {
            appKey: data.appKey
        },
        query: {
            name: data.name,
            toolkits: data.toolkits,
            auth_config_ids: data.authConfigIds,
            page_no: data.pageNo,
            limit: data.limit
        },
        errors: {
            400: 'Bad request. The query parameters may be invalid or in an incorrect format.',
            401: 'Unauthorized. Authentication is required or the provided credentials are invalid.',
            403: 'Forbidden. The authenticated user does not have permission to view MCP servers for this application.',
            404: 'Application not found. No application with the specified key exists.',
            500: 'Internal server error. An unexpected error occurred while processing the request.'
        }
    });
};

/**
 * List files with optional app and action filters
 * Retrieves a list of files associated with the authenticated project. Results can be filtered by toolkit and tool slugs.
 * @param data The data for the request.
 * @param data.toolkitSlug Filter files by app slug. Example: "file-converter"
 * @param data.toolSlug Filter files by action slug. Example: "convert-to-pdf"
 * @param data.limit Number of items per page
 * @param data.cursor Cursor for pagination. The cursor is a base64 encoded string of the page and limit. The page is the page number and the limit is the number of items per page. The cursor is used to paginate through the items. The cursor is not required for the first page.
 * @returns unknown Successfully retrieved files
 * @throws ApiError
 */
export const getFilesList = (data: GetFilesListData = {}): CancelablePromise<GetFilesListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/files/list',
        query: {
            toolkit_slug: data.toolkitSlug,
            tool_slug: data.toolSlug,
            limit: data.limit,
            cursor: data.cursor
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Create presigned URL for request file upload to S3
 * Generates a presigned URL for uploading a file to S3. This endpoint handles deduplication by checking if a file with the same MD5 hash already exists.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully created upload URL for request file
 * @throws ApiError
 */
export const postFilesUploadRequest = (data: PostFilesUploadRequestData = {}): CancelablePromise<PostFilesUploadRequestResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/files/upload/request',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad Request',
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Not Found',
            410: 'Gone',
            429: 'Too Many Requests',
            500: 'Internal Server Error',
            501: 'Not Implemented'
        }
    });
};

/**
 * Create presigned URL for response file upload to S3 (admin only)
 * Generates a presigned URL for uploading response files to S3. This endpoint is restricted to admin users only and requires a valid admin token.
 * @param data The data for the request.
 * @param data.adminToken Required admin token for authorization to upload response files. This token must match the APOLLO_ADMIN_TOKEN environment variable.
 * @param data.requestBody
 * @returns unknown Successfully created upload URL for response file
 * @throws ApiError
 */
export const postFilesUploadResponse = (data: PostFilesUploadResponseData): CancelablePromise<PostFilesUploadResponseResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/files/upload/response',
        query: {
            adminToken: data.adminToken
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad Request',
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Not Found',
            410: 'Gone',
            429: 'Too Many Requests',
            500: 'Internal Server Error',
            501: 'Not Implemented'
        }
    });
};

/**
 * Get NanoId from UUID
 * Convert a legacy UUID to its corresponding NanoId for migration purposes. This endpoint facilitates the transition from UUID-based identifiers to the more compact NanoId format used in the v3 API.
 * @param data The data for the request.
 * @param data.uuid The legacy UUID that needs to be converted to a NanoId
 * @param data.type The type of resource that the UUID belongs to
 * @param data.xApiKey
 * @returns unknown Successfully retrieved NanoId for the given UUID
 * @throws ApiError
 */
export const getMigrationGetNanoid = (data: GetMigrationGetNanoidData): CancelablePromise<GetMigrationGetNanoidResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/migration/get-nanoid',
        headers: {
            'x-api-key': data.xApiKey
        },
        query: {
            uuid: data.uuid,
            type: data.type
        },
        errors: {
            400: 'Bad Request - Invalid UUID or resource not found',
            401: 'Unauthorized - Invalid or missing API key',
            404: 'Not Found - The UUID does not correspond to any resource of the specified type',
            410: 'Gone - The UUID does not correspond to any resource of the specified type',
            500: 'Internal server error - An unexpected error occurred during processing'
        }
    });
};